import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
//import { Clipboard } from '@angular/cdk/clipboard';

import { DataCollection } from '../../models/site-content/data-collection.model';
import { CopySiteService } from '../../services/copy-site.service';
import { AsyncJobService } from '../../services/async-job.service';
import { AsyncJob } from '../../models/async-job.model';
import { AsyncJobDialogBase, JOB_COMPLETED_MESSAGE } from '../async-job-base/async-job-base.dialog';
import { ExportSiteMetrics } from '../../models/export-import/export-site-metrics.model';
import { IAsyncJobMonitor } from '../../interfaces/iasync-job-monitor.interface';

@Component({
    selector: 'app-export-site',
    templateUrl: './export-site.dialog.html',
    styleUrls: [
        '../async-job-base/async-job-base.dialog.scss',
        './export-site.dialog.scss'
    ],
    standalone: false
})
export class ExportSiteDialog extends AsyncJobDialogBase implements OnInit, IAsyncJobMonitor {
    // Properties.
    private downloadExportedSiteUrl: string = null;
    private exportSiteMetrics: ExportSiteMetrics = null;
    private exportStructureOnly: boolean = false;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ExportSiteDialog>,
        @Inject(MAT_DIALOG_DATA) public siteToExport: DataCollection,
        private copySiteService: CopySiteService,
        protected injectedAsyncJobService: AsyncJobService)
    {
        super(injectedAsyncJobService);

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Static method.
    public static createDialogConfig(siteToExport: DataCollection): MatDialogConfig {
        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = siteToExport; //this.contextMenu.menuData.item;

        return dialogConfig;
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'ExportSiteDialog';
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    // Accessor methods.
    public get ExportStructureOnly(): boolean {
        return this.exportStructureOnly;
    }

    public set ExportStructureOnly(value: boolean) {
        this.exportStructureOnly = value;
    }

    public get ExportSiteName(): string {
        return (this.siteToExport.name);
    }

    public get DownloadExportedSiteUrl(): string {
        return (this.downloadExportedSiteUrl);
    }

    public get ExportStatus(): string {
        let status: string = null;

        if ((!this.jobInProgress) && (this.asyncJobInfo == null)) {
            status = 'Not started';
        } else if (this.jobInProgress) {
            status = 'Export in progress';
        } else if (!this.jobErrorOccurred) {
            if (this.downloadExportedSiteUrl != null) {
                status = "Complete - Click 'Download' to save";
            } else {
                status = JOB_COMPLETED_MESSAGE;//'Completed';
            }            
        } else {
            status = 'An export error occurred';
        }

        return (status);
    }

    public get ExecutionSummaryText(): string {
        let summaryText: string = super.deriveExecutionSummaryText(this.exportSiteMetrics);

        return (summaryText);
    }

    // Implement interface IAsyncJobMonitor.
    public startMonitoringExistingJob(asyncJob: AsyncJob): void {
        this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobCompletedArrowFunction);
    }

    // Handle dialogue action(s).
    public startSiteExport(): void {
        // Initiate the export.
        this.copySiteService.exportSite(this.siteToExport.id, this.exportStructureOnly, this.ComponentClassName).then(asyncJob => {
            // Save the returned job key.
            this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobCompletedArrowFunction);
        });

        return;
    }

    // Private methods.
    private jobCompletedArrowFunction = (asyncJob: AsyncJob): void => {
        // Ask the copy site service to download the
        // exported site(in a separate browser tab).
        if (asyncJob.status == AsyncJob.STATUS_COMPLETE) {
            //this.exportSiteMetrics = ExportSiteDialog.parseMetrics(this.jobCompletedMessageText);

            this.downloadExportedSiteUrl = this.copySiteService.getDownloadExportedSiteUrl(asyncJob);
        } else if ((asyncJob.stdOut != null) && (asyncJob.stdOut.trim() != '')) {
            this.exportSiteMetrics = ExportSiteDialog.parseMetrics(asyncJob.stdOut);
        }

        return;
    }

    private static parseMetrics(jobMetricsJson: string): ExportSiteMetrics {
        let jobMetricsObject: Object = JSON.parse(jobMetricsJson);
        let metrics: ExportSiteMetrics = new ExportSiteMetrics(jobMetricsObject);

        return (metrics);
    }

}
